import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import DogNameInput from "../../components/form/DogName.input";
import EamilInput from "../../components/form/Email.input";
import Header from "../../components/Header.component";
import ArrowIcon from "../../components/svgs/icons/Arrow.icon";
import TermsCompliance from "../../components/TermsCompliance.component";
import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import api from "../../services/api";
import { getVpFontSize } from "../../services/utils";
import { BallButton, NavItem, TertiaryFitContentButton } from "../../styles/Button.style";
import { RootContainer } from "../../styles/Container.style";
import { ErrorMessage, FormTitle, StyledForm } from "../../styles/Form";
import { Column, Gap, Row } from "../../styles/Utils";

interface FormData {
  email: string;
  dogName: string;
}

export default function LandingPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const viewportWidth = usePwaViewportWidth();

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm<FormData>({ mode: "onChange" });

  const onSubmit = async (data: FormData) => {
    // mixpanel.track("Landing Submit");
    const { email, dogName } = data;
    try {
      const response = await api.checkUser(data);
      if (response.data.status === "new_user") {
        navigate(routeList.signup, {
          state: { email, dogName },
        });
      } else if (response.data.status === "existing_user") {
        navigate(routeList.login, {
          state: { email, dogName },
        });
      }
    } catch (err) {
      console.log("Error checking profile existence", err);
      alert("Error checking profile existence");
    }
  };

  return (
    <RootContainer $background={theme.color.primary} $topSafe={true}>
      <Column $alignItem="center" $maxHeight>
        <NavItemOvl to="/" onClick={() => localStorage.removeItem("isFirstVisit")}>
          <BallButton $position="right" $color={theme.color.tertiary}>
            <ArrowIcon color={theme.color.tertiaryLight} />
          </BallButton>
        </NavItemOvl>
        <Header sloganImgSrc="/slogans/slogan-white.png" />
        <ImageContainer>
          <img src="/illustrations/master-dog-dance.png" />
        </ImageContainer>
        <Gap $height={1} />
        <FormTitle $fontSize={getVpFontSize(viewportWidth, 10)}>{lang.landingPage.form.title}</FormTitle>
        <Gap $height={1} />
        <StyledForm onSubmit={handleSubmit(onSubmit)}>
          <EamilInput register={register} name="email" />
          {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
          <Gap $height={1} />
          <DogNameInput register={register} name="dogName" />
          {errors.dogName && <ErrorMessage>{errors.dogName.message}</ErrorMessage>}
          <Gap $height={1.5} />
          <TertiaryFitContentButton type="submit" disabled={!isValid}>
            <span>{lang.buttons.next}</span>
          </TertiaryFitContentButton>
          <Gap $height={2} />
          <TermsCompliance />
        </StyledForm>
      </Column>
    </RootContainer>
  );
}

export const ImageContainer = styled(Row)`
  display: flex;
  align-items: center;
  height: 25dvh;
  width: 90%;
`;

const NavItemOvl = styled(NavItem)`
  position: absolute;
  right: ${(props) => props.theme.rootContainerInlinePadding};
`;
